// extracted by mini-css-extract-plugin
export default {"link":"styles_link__cgvu8","block":"styles_block__2l9Yh","active":"styles_active__-UxAc","disabled":"styles_disabled__en-LG"};